import { ReducerActions, ReducerState } from './Changepassword.types';

export const initialState: ReducerState = {
  username: '',
  resetPasswordToken: '',
};

export const changePasswordReducer = (state: ReducerState, action: ReducerActions) => {
  switch (action.type) {
    case 'CLEAR_CONTEXT':
      return {
        username: '',
        resetPasswordToken: '',
      };
    case 'UPDATE_CONTEXT':
      return {
        username: action.payload.username,
        resetPasswordToken: action.payload.resetPasswordToken,
      };
    default:
      return state;
  }
};
